import {createContext} from 'react';

const TwoFactorAuthContext = createContext();
export default TwoFactorAuthContext;
